import * as validators from 'vuelidate/lib/validators'
import * as ruleNames from '../constants/ruleNames'
import { Evaluators } from '../types'
import { endGreaterThanStart } from './scheduleForm/endGreaterThanStart'

const { helpers } = validators

const betweenLength = (min: number, max: number) =>
  helpers.withParams(
    { type: ruleNames.BETWEEN_LENGTH, min: min, max: max },
    (value: string | number) =>
      helpers.len(value) >= min && helpers.len(value) <= max
  )

const sameAs = (evaluators: Evaluators, field: string) =>
  helpers.withParams(
    { type: ruleNames.SAME_AS, field },
    (value: string) => String(value) === String(evaluators[field].$model)
  )

/**
 * 最低 `requieredNumber` 個の入力が必要
 * @param evaluators
 * @param fields
 * @param requieredNumber
 */
const requiredAtLeastN = (
  evaluators: Evaluators,
  {
    fields,
    requieredNumber = 1
  }: { fields: Array<string>; requieredNumber: number }
) => {
  return helpers.withParams(
    { type: ruleNames.SAME_AS, fields, requieredNumber },
    () => {
      let counter = 0

      return fields.some(field => {
        if (!evaluators[field].$model) {
          return false
        }

        counter++

        if (counter >= requieredNumber) {
          return true
        }

        return false
      })
    }
  )
}

export const getValidator = (
  ruleName: string,
  params: any,
  evaluators: Evaluators
) => {
  switch (ruleName) {
    case ruleNames.MIN_LENGTH:
    case ruleNames.MAX_LENGTH:
    case ruleNames.MIN_VALUE:
    case ruleNames.MAX_VALUE:
      return validators[ruleName](params as number)

    case ruleNames.BETWEEN:
      return validators[ruleName](params[0], params[1])

    case ruleNames.BETWEEN_LENGTH:
      return betweenLength(params[0], params[1])

    case ruleNames.REQUIRED:
    case ruleNames.ALPHA_NUM:
    case ruleNames.INTEGER:
    case ruleNames.EMAIL:
    case ruleNames.URL:
      return validators[ruleName]

    case ruleNames.HIRAGANA:
      return helpers.regex(ruleNames.HIRAGANA, /^[\u3041-\u309F]*$/)

    case ruleNames.SAME_AS:
      return sameAs(evaluators, params as string)

    case ruleNames.REQUIRED_AT_LEAST_N:
      return requiredAtLeastN(evaluators, params)

    case ruleNames.END_GREATER_THAN_START:
      return endGreaterThanStart(evaluators)
  }
}
